export default "__VITE_ASSET__DRxfvdFW__"